import {FC} from 'react';
import {t} from 'ttag';
import {toCurrency} from 'utils/number';

type PriceCalculationProps = {
    isError: boolean;
    isInvalid?: boolean;
    isLoading: boolean;
    isSuccess: boolean;
    value?: number;
};

const PriceCalculation: FC<PriceCalculationProps> = ({
    isError = false,
    isInvalid = false,
    isLoading = false,
    isSuccess = false,
    value,
}) => {
    if (isInvalid) {
        return <div className="p-3 text-center text-green-800">---</div>;
    }

    if (isLoading) {
        return (
            <div className="p-3 text-center text-green-800" role="progressbar">
                {t`Loading`}
            </div>
        );
    }

    if (isError) {
        return (
            <div
                aria-label="server error"
                className="border-gold-200 bg-gold-50 p-3 text-center text-light-primary"
                role="alert"
            >
                {t`Error`}
            </div>
        );
    }

    if (isSuccess && value) {
        const priceValue = toCurrency({currency: 'JPY', value});

        return (
            <div className="p-3 text-center text-green-800">
                {t`${priceValue} (+ Tax)`}
            </div>
        );
    }

    return <div className="p-3 text-center text-green-800">---</div>;
};

export default PriceCalculation;
